import { makeStyles, gridClasses } from '@rbx/ui';

const useGridContainerStyles = makeStyles()(() => ({
  root: {
    marginTop: 0,
    [`& > .${gridClasses.item}`]: {
      paddingTop: 0,
    },
  },
}));

export default useGridContainerStyles;
